"use client";

import { Table } from "@mantine/core";

import { usePenaltyRules } from "@/components/model/user/_hooks/usePenaltyRules";
import type { PenaltyRuleRow } from "@/components/model/user/_type";
import { H2, Text } from "@/components/ui/elements";

type PenaltyTableProps = {
  /** 指定時は GraphQL を使わずこのデータを表示（テスト・Story 用） */
  data?: PenaltyRuleRow[];
};

export function PenaltyTable({ data }: PenaltyTableProps) {
  const penaltyRulesFromApi = usePenaltyRules({ skip: data !== undefined });
  const displayData = data ?? penaltyRulesFromApi;

  const penaltyRows = displayData.map((body, i) => (
    <Table.Tr key={i}>
      <Table.Td w={170} maw={170}>
        {body.cancelTime}
      </Table.Td>
      <Table.Td>
        <Text c="red" fw="bold" key={i} ta="center">
          {body.penaltyPoint}
        </Text>
      </Table.Td>
    </Table.Tr>
  ));

  return (
    <>
      <H2>【ペナルティルール】</H2>
      <Table title="ペナルティポイント" withTableBorder withColumnBorders>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>キャンセル時間*</Table.Th>
            <Table.Th w={80} maw={80} ta="center">
              ペナルティ
              <br />
              ポイント
            </Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>{penaltyRows}</Table.Tbody>
      </Table>
      <Text c="dimmed">＊ 勤務開始時間を基準としたキャンセル時間。</Text>
    </>
  );
}
